import { engine } from "../..";
import { FilterGroupsState } from "../technicalSelectionRepository";

export function buildEngineSelectedFilters(
  filterGroups: FilterGroupsState | null | undefined,
) {
  const currentSelection = new engine.SelectedFiltersVector();

  for (const groupValues of Object.values(filterGroups?.filterGroups ?? {})) {
    for (const { id, value } of groupValues) {
      const selectedFilter = new engine.SelectedFilter(
        id,
        parseValue(value),
        filterGroups?.lastUpdatedFilterId === id,
      );
      currentSelection.push_back(selectedFilter);
      // push_back creates a copy of the object, so we can safely call delete on the original
      // object without affecting the one in the vector
      selectedFilter.delete();
    }
  }

  return currentSelection;
}

function parseValue(value: boolean | number | string | null) {
  if (typeof value === "boolean") return value ? "on" : "off";
  return `${value}`;
}
